import React from 'react';
import { MotionConfig } from 'framer-motion';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0">
      <ContactPage data-id="element-1" />
    </MotionConfig>;
}